import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-screen-content',
  templateUrl: './screen-content.component.html',
  styleUrls: ['./screen-content.component.scss'],
})
export class ScreenContentComponent {
  @Input() isLoading = false;
  // @Input() heading?: TemplateRef<any> | null = null;
  // @Input() body?: TemplateRef<any> | null = null;
  // @Input() bottomNav?: TemplateRef<any> | null = null;

  constructor() {}
}
